<template>
  <div class="d-flex justify-content-center gap-3">
    <a href="https://www.facebook.com/IusaMexico/" target="_blank">
      <i class="mdi mdi-facebook fs-3" :class="iconColor" title="Facebook" />
    </a>
    <a href="https://www.instagram.com/iusamexico/" target="_blank">
      <i class="mdi mdi-instagram fs-3" :class="iconColor" title="Instagram" />
    </a>
    <a href="https://twitter.com/iusamexico" target="_blank">
      <i class="mdi mdi-twitter fs-3" :class="iconColor" title="Twitter" />
    </a>
    <a href="https://www.youtube.com/channel/UCt2JxYdlCygc11tfH6s0sWA" target="_blank">
      <i class="mdi mdi-youtube fs-3" :class="iconColor" title="YouTube" />
    </a>
    <a href="https://wa.me/5215551181585" target="_blank" >
      <i class="mdi mdi-whatsapp fs-3" :class="iconColor" title="WhatsApp" />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: 'text-white'
    }
  }
}
</script>